<template>
    <div v-if="dataIsLoaded" class="min-w-screen min-h-screen flex items-center justify-center">
        <div v-if="showSuccessfulMessage" class="w-[500px] h-auto bg-white rounded-lg px-[4rem] py-[3rem]">
            <p class="mb-6 text-center">Мы отправили письмо с подтверждением на указанный email. Пожалуйста, проверьте указанный email.</p>
            <div class="flex items-center justify-center">
                <router-link :to="{ name: 'sign-in'}" class="w-full bg-custom-blue hover:bg-custom-blue-hover text-center text-white font-medium rounded-lg text-sm px-5 py-2">Хорошо</router-link>
            </div>
        </div>
        <div v-else-if="tokenIsValid" class="w-[500px] h-auto bg-white rounded-lg px-[4rem] py-[3rem]">
            <form @submit.prevent="updateEmail">
                <p class="text-2xl mb-8">Обновите email</p>
                <TextInput v-model:textParam="email" labelContent="Новый email" ref="emailInput" type="email" class="mb-6"/>
                <button type="submit" class="w-full bg-custom-blue hover:bg-custom-blue-hover text-center text-white font-medium rounded-lg text-sm px-5 py-2 mb-8">Обновить</button>
            </form>
        </div>
        <div v-else class="w-[500px] h-auto bg-white rounded-lg px-[4rem] py-[3rem]">
            <p class="text-center">Похоже ссылка устарела</p>
            <p class="text-center">Попробуйте запросить письмо еще раз</p>
        </div>
    </div>
    <div v-else>
        <LoadingComponent/>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    import LoadingComponent from '@/components/LoadingComponent.vue';
    import TextInput from '@/components/InputComponents/TextInput.vue';

    export default {
        name: "ResetPhone",
        components: {
            LoadingComponent,
            TextInput, 
        },
        computed: {
            ...mapState(["profileData"]),
        },
        data() {
            return {
                email: null,
                tokenIsValid: false,
                dataIsLoaded: false,
                token: null,
                showSuccessfulMessage: false,
            }
        },
        methods: {
            async checkToken() {
                const token = this.$route.query.token;
                if (!token) {
                    this.dataIsLoaded = true;
                    return;
                }

                const result = await this.$store.dispatch("checkToken", token);
                if (result.successfully) {
                    this.tokenIsValid = true;
                }
                this.token = token;
                this.dataIsLoaded = true;
            },
            validateData() {
                if (!this.email) {
                    const emailInput = this.$refs.emailInput.$refs.textInput;
                    emailInput.setCustomValidity("Введите новый email");
                    emailInput.reportValidity();
                    return false;
                }
                if (!this.$globalMethods.validateEmail(this.email)) {
                    const emailInput = this.$refs.emailInput.$refs.textInput;
                    emailInput.setCustomValidity("Введите корретный email");
                    emailInput.reportValidity();
                    return false;
                }
                return true;
            },
            async updateEmail() {
                if (!this.validateData()) {
                    return;
                }
                const data = {
                    temporary_token: this.token,
                    email: this.email,
                }
                let result = await this.$store.dispatch("sendRequestToChangeEmailContinue", data);
                if (result.successfully) {
                    this.$notify("Письмо с подтверждением успешно отправлено на email!", "black");
                    this.showSuccessfulMessage = true;
                } else {
                    if (result.detail == "User already exists.") {
                        const emailInput = this.$refs.emailInput.$refs.textInput;
                        emailInput.setCustomValidity("Пользователь с таким email уже существует.");
                        emailInput.reportValidity();
                    } else if (result.detail == "Email matches the existing one.") {
                        const emailInput = this.$refs.emailInput.$refs.textInput;
                        emailInput.setCustomValidity("Введите email, который отличается от текущего.");
                        emailInput.reportValidity();
                    }
                }
            }
        },
        created() {
            this.checkToken();
        }
    }
</script>